export default "__VITE_ASSET__Pbu8wLRJ__"